import React from "react";
import { Link } from "react-router-dom";
import { S3URL, BW_TITLE_TREATMENTS } from "../../../data/globalConstants";

export default function NavMenuItem({ submenuItem, parent, isMobile }) {
  // Find matching treatment by slug
  const matchedTreatment = BW_TITLE_TREATMENTS.find(
    (item) => item.slug === submenuItem?.slug,
  );

  // Decide which image to use
  const imageSrc = matchedTreatment
    ? S3URL + matchedTreatment.image
    : S3URL + submenuItem?.title_treatment;

  const imageClass = `
    ${isMobile ? "nav-mobile-accordion-show-image" : ""}
    submenu-tt
    ${!matchedTreatment ? "white-overlay" : ""}
  `.trim();

  return (
    <div
      key={submenuItem?.slug}
      className={isMobile ? "nav-mobile-accordion-show" : "submenu-item"}
    >
      <Link to={`/${parent.slug}/${submenuItem?.slug}`}>
        <img alt={submenuItem?.title} src={imageSrc} className={imageClass} />
      </Link>
    </div>
  );
}
